import LoadingSpinner from "@/components/LoadingSpinner";
import PollCardWrapper from "@/components/Polls/PollCardWrapper";
import { getUserID } from "@/lib/auth/auth-server-func";
import MainLayout from "@/lib/layout/MainLayout";
import { useBookmarkedPolls } from "@/lib/tanstack-query/hooks/useBookmarks";
import { createFileRoute, redirect } from "@tanstack/react-router";
import { Loader2 } from "lucide-react";
import { useEffect } from "react";
import { useInView } from "react-intersection-observer";

export const Route = createFileRoute("/_dashboard/bookmarks")({
  component: RouteComponent,
  beforeLoad: async ({ context }) => {
    const userID = await getUserID();
    return { userID };
  },
  loader: async ({ context }) => {
    if (!context.userID) {
      throw redirect({ to: "/" });
    }
    return { userID: context.userID };
  },
});

function RouteComponent() {
  const { ref, inView } = useInView();
  const {
    data: polls,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    isLoading,
  } = useBookmarkedPolls();

  useEffect(() => {
    if (inView && hasNextPage && !isFetchingNextPage) {
      fetchNextPage();
    }
  }, [fetchNextPage, inView, isLoading]);

  return (
    <>
      <MainLayout.Header headline="Bookmarks"></MainLayout.Header>
      <MainLayout.Content hasPadding={false}>
        <PollCardWrapper polls={polls?.pages.flatMap((page) => page) ?? []} />
        <div>
          {isLoading ? <LoadingSpinner /> : null}
          {hasNextPage ? <LoadingSpinner ref={ref} /> : null}
        </div>
      </MainLayout.Content>
    </>
  );
}
